<template>
	<div>
		<locum-booking-confirmed />
		<locum-upcoming-bookings />
		<locum-past-bookings />
		<locum-increase-availability-ad />
	</div>
</template>

<script>
import LocumBookingConfirmed from '@/components/ui/dashboard/locum/cards/LocumBookingConfirmed';
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';
import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';

export default {
	name: 'LocumSuccessBookingConfirmed',
	components: {
		LocumBookingConfirmed,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumIncreaseAvailabilityAd,
	},
	data: () => ({}),
};
</script>
